import { IAIVideoProject } from 'types/aiVideo'
import { IBaseMediaItem } from 'types/media'

export const convertAiVideoToBaseMediaItem = (
  video?: IAIVideoProject
): IBaseMediaItem => {
  if (!video) {
    throw new Error('Video data is required')
  }

  return {
    fileName: `ai-video-${video.id}.mp4`,
    type: 'aiVideo',
    originalWidth: video.width!,
    originalHeight: video.height!,
    path: video.videoUrl,
    duration: video.videoDurationSeconds,
    assetId: String(video.id)
  }
}
